import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { ConfigService, AppDataService, PromosService } from 'app/services';
import { EditTableConfig } from 'app/models/configs/edit-table-config';
import { ExportFileTypeModel, FieldTypeEnum, RiderServiceTypeModel } from 'app/models';
import { ColumnSelectorComponent } from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';
import { Utils } from 'app/utils';
import * as moment from 'moment/moment';

@Component({
	selector: 'referral-report',
	templateUrl: './referral-report.component.html',
	styleUrls: ['./referral-report.component.scss',
		'../../../../styles/paginator.scss'],
	providers: [MessageService]
})

export class RefferalReportComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild(ColumnSelectorComponent)
	public columnSelector!: ColumnSelectorComponent;

	public serviceTypeList = !this.appDataService.isBoracayLocation
		? RiderServiceTypeModel.RiderServiceTypeXpressList : RiderServiceTypeModel.RiderServiceTypeBoracayList;

	referrals: Array<any> = [];
	cols: any[] = [
		{
			field: 'TransactionId',
			header: 'Id',
			width: '8%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'transactionId',
			placeholder: 'Type ID',
			active: true,
		},
		{
			field: 'ReferralCode',
			header: 'Referral Code',
			width: '8%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'referralCode',
			placeholder: 'Type Code',
			active: true,
		},
		{
			field: 'InviterUserId',
			header: 'Inviter User Id',
			width: '8%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'inviterUserId',
			placeholder: 'Type ID',
			active: true,
		},
		{
			field: 'InviterName',
			header: 'Inviter Name',
			width: '12%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'inviterName',
			placeholder: 'Type Name',
			active: true,
		},
		{
			field: 'InviterWalletCreditedAmount',
			header: 'Inviter Wallet Credited Amount',
			width: '8%',
			fieldType: FieldTypeEnum.InputDecimalNumber,
			model: 'inviterWalletCreditedAmount',
			placeholder: 'Type Amount',
			active: true,
		},
		{
			field: 'InvitedUserId',
			header: 'Invited User Id',
			width: '8%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'invitedUserId',
			placeholder: 'Type ID',
			active: true,
		},
		{
			field: 'InvitedName',
			header: 'Invited Name',
			width: '12%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'invitedName',
			placeholder: 'Type Name',
			active: true,
		},
		{
			field: 'InvitedWalletCreditedAmount',
			header: 'Invited Wallet Credited Amount',
			width: '8%',
			fieldType: FieldTypeEnum.InputDecimalNumber,
			model: 'invitedWalletCreditedAmount',
			placeholder: 'Type Amount',
			active: true,
		},
		{
			field: 'BookingId',
			header: 'Booking Id',
			width: '8%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'bookingId',
			placeholder: 'Type ID',
			active: true,
		},
		{
			field: 'ServiceTypeName',
			header: 'Service Type',
			width: '10%',
			fieldType: FieldTypeEnum.Dropdown,
			model: 'serviceType',
			placeholder: 'Select Service Type',
			options: this.serviceTypeList,
			active: true,
		},
		{
			field: 'Platform',
			header: 'Platform',
			width: '8%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'platform',
			placeholder: 'Type Name',
			active: true,
		},
		{
			field: 'DisplayFormatUsedAt',
			header: 'Used At',
			width: '15%',
			fieldType: FieldTypeEnum.Calendar,
			model: 'usedAt',
			placeholder: 'Select Date',
			active: true,
		}
	];
	defaultCols = this.cols.map(x => x);

	rowsPerPage: number = 15;
	totalRecords: number = -1;
	fieldTypeEnum = FieldTypeEnum;
	referralHeaderSearch: any = {
		transactionId: null,
		referralCode: null,
		inviterUserId: null,
		inviterName: null,
		inviterWalletCreditedAmount: null,
		invitedUserId: null,
		invitedName: null,
		invitedWalletCreditedAmount: null,
		bookingId: null,
		serviceType: null,
		platform: null,
		usedAt: null,
		startDate: null,
		endDate: null
	};
	first: number = 0;
	sortField: string | string[] = 'TransactionId';
	sortOrder: number = -1;
	loading: boolean = false;
	searchTimer: any = 0;
	tableName: string = EditTableConfig.REFERRAL_REPORT;
	exportHeaderColumns: string[] = [];
	exportDataColumns: string[] = [];
	private sortFieldMapping: { [key: string]: string } = {
		ServiceTypeName: 'ServiceType',
		DisplayFormatUsedAt: 'UsedAt'
	};

	public showExportSidebar: boolean = false;
	public exportLoading: boolean = false;
	public exportData: any = {};

	breadcrumbs: MenuItem[] = [{ icon: 'icon_marketing' }, { label: 'Reports' }, { label: 'Referral Report' }];

	constructor(
		private messageService: MessageService,
		private promosService: PromosService,
		public configService: ConfigService,
		private cdRef: ChangeDetectorRef,
		public appDataService: AppDataService) { }

	ngAfterViewInit(): void {
		this.cdRef.detectChanges();
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
		}
	}

	@Output() changedVisibleExportSidebarEmit = new EventEmitter<boolean>();
	changedVisibleExportSidebar(increased: any) {
		this.changedVisibleExportSidebarEmit.emit(increased);
	}

	showSidebar() {
		this.showExportSidebar = true;
	}

    /**
     * Build referral DTO. Use isExport=true for export payload (includes file fields),
     * otherwise include pagination fields when provided.
     */
    private getReferralDto(isExport: boolean, skip?: number, take?: number): any {
        const base: any = {
            TransactionId: this.referralHeaderSearch.transactionId !== null && this.referralHeaderSearch.transactionId !== ''
                ? Number(this.referralHeaderSearch.transactionId) : null,
            ReferralCode: this.referralHeaderSearch.referralCode || null,
            InviterUserId: this.referralHeaderSearch.inviterUserId !== null && this.referralHeaderSearch.inviterUserId !== ''
                ? Number(this.referralHeaderSearch.inviterUserId) : null,
            InviterName: this.referralHeaderSearch.inviterName || null,
            InviterWalletCreditedAmount: this.referralHeaderSearch.inviterWalletCreditedAmount !== null ?
                Number(this.referralHeaderSearch.inviterWalletCreditedAmount) : null,
            InvitedUserId: this.referralHeaderSearch.invitedUserId !== null && this.referralHeaderSearch.invitedUserId !== ''
                ? Number(this.referralHeaderSearch.invitedUserId) : null,
            InvitedName: this.referralHeaderSearch.invitedName || null,
            InvitedWalletCreditedAmount: this.referralHeaderSearch.invitedWalletCreditedAmount !== null ?
                Number(this.referralHeaderSearch.invitedWalletCreditedAmount) : null,
            BookingId: this.referralHeaderSearch.bookingId !== null && this.referralHeaderSearch.bookingId !== ''
                ? Number(this.referralHeaderSearch.bookingId) : null,
            ServiceType: this.referralHeaderSearch.serviceType !== null && this.referralHeaderSearch.serviceType !== ''
                ? Number(this.referralHeaderSearch.serviceType) : null,
            Platform: this.referralHeaderSearch.platform || null,
            UsedAt: this.referralHeaderSearch.usedAtFormatted ? moment(this.referralHeaderSearch.usedAt).toDate() : null,
            UsedAtFrom: this.referralHeaderSearch.startDateFormatted ?
                moment(this.referralHeaderSearch.startDate).startOf('day').toDate() : null,
            UsedAtTo: this.referralHeaderSearch.endDateFormatted ?
                moment(this.referralHeaderSearch.endDate).endOf('day').toDate() : null,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            ClientLocationType: this.appDataService.getClientLocationType(),
        };

        if (isExport) {
            base.IsExport = true;
            base.FileType = this.exportData.fileType;
            base.HeaderColumns = this.exportHeaderColumns;
            base.DataColumns = this.exportDataColumns;
        }
        else {
            base.IsExport = false;
			if (skip != null) { base.Skip = skip; }
			if (take != null) { base.Take = take; }
        }

        return base;
    }

	export() {
		if (!this.exportData.fileType) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select file type' });
			return;
		}

		this.exportLoading = true;
		const requestDto = this.getReferralDto(true);

		this.promosService.downloadReferralReport(requestDto, this.messageService)
			.then(data => {
				if (data.ok && data.body && data.body.size > 0) {
					Utils.saveFileResponse(data, 'Referral-Report-' + moment(new Date()).format('DD MMM YYYY hh:mm:ss A'), this.exportData.fileType);
					this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Report downloaded successfully.' });
				} else {
					this.messageService.add({
						severity: 'warn',
						summary: 'No Data',
						detail: 'No report data available for the selected criteria.'
					});
				}
				this.exportLoading = false;
			})
			.catch(err => {
				this.exportLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while fetching export referrals.' });
				console.error(err);
			});
	}

	onSelectedColumnsChange(event: any[]) {
		if (event && event.length > 0) {
			this.cols = event;
		}
		else {
			this.cols = [...this.defaultCols];
		}
		this.updateExportColumns();
	}

	updateExportColumns(): void {
		this.exportHeaderColumns = this.cols.map(x => x.header);
		this.exportDataColumns = this.cols.map(x => x.field);
	}

	handleLazyLoad(event: TableLazyLoadEvent): void {
		const skip = event.first ?? 0;
		if (event.rows) {
			this.rowsPerPage = event.rows;
		}

		if (!event.sortField) {
			this.sortField = 'Id';
			this.sortOrder = -1;
		}
		else {
			const rawSortField = typeof event.sortField === 'string' ? event.sortField : 'Id';
			this.sortField = this.sortFieldMapping[rawSortField] || rawSortField;
			this.sortOrder = event.sortOrder ?? 1;
		}

		if (this.columnSelector) {
			this.columnSelector.loadTableSettings(this.tableName);
		} else {
			this.cols = [...this.defaultCols];
			this.updateExportColumns();
		}

		this.loadReferrals(skip);
	}

	handleFilterChange(modelField: string, event: any): void {
		let value = event?.target?.value ?? event;
		if (value === '') {
			value = null;
		}

		this.referralHeaderSearch[modelField] = value;

		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
		}

		this.searchTimer = setTimeout(() => {
			this.first = 0;
			this.loadReferrals(0);
		}, 1000);
	}

	onChangeHeaderFilterDropDown(modelField: string, event: any) {
		this.referralHeaderSearch[modelField] = event;

		if (modelField === 'usedAt' && this.referralHeaderSearch.usedAt instanceof Date) {
			this.referralHeaderSearch.usedAtFormatted = moment(this.referralHeaderSearch.usedAt).format('YYYY-MM-DD');
		} else if (modelField === 'usedAt') {
			this.referralHeaderSearch.usedAtFormatted = null;
		}

		if (modelField === 'StartDate' && this.referralHeaderSearch.startDate instanceof Date) {
			this.referralHeaderSearch.startDateFormatted = moment(this.referralHeaderSearch.startDate).format('YYYY-MM-DD');
		} else if (modelField === 'StartDate') {
			this.referralHeaderSearch.startDateFormatted = null;
		}

		if (modelField === 'EndDate' && this.referralHeaderSearch.endDate instanceof Date) {
			this.referralHeaderSearch.endDateFormatted = moment(this.referralHeaderSearch.endDate).format('YYYY-MM-DD');
		} else if (modelField === 'EndDate') {
			this.referralHeaderSearch.endDateFormatted = null;
		}

		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
		}
		this.searchTimer = setTimeout(() => {
			this.first = 0;
			this.loadReferrals(0);
		}, 1000);
	}

	loadReferrals(skip: number) {
		this.loading = true;
		const requestDto = this.getReferralDto(false, skip, this.rowsPerPage);

		this.promosService.getReferralReport(requestDto, this.messageService)
			.then(data => {
				this.loading = false;
				if (!data.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage || 'Failed to load referrals.' });
					return;
				}
				this.first = skip;
				this.totalRecords = data.TotalRecords;
				this.referrals = data.ReferralReports.map((o: any) => {
					o.DisplayFormatUsedAt = Utils.utcToFormatedLocalDateStr(o.UsedAt);
					return o;
				});
			})
			.catch(err => {
				this.loading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while fetching referrals.' });
				console.error(err);
			});
	}

	protected readonly ExportFileTypeModel = ExportFileTypeModel;
}
